export const SOLICITANTE_GET = "deca.SOLICITANTE_GET";
export const SOLICITANTE_SET = "deca.SOLICITANTE_SET";
export const SOLICITANTE_ENDERECO_SET = "deca.SOLICITANTE_ENDERECO_SET";
export const DADOSSOLICITANTE_RESETFORM = "deca.DADOSSOLICITANTE_RESETFORM";
